<template>
  <v-container v-if="tune">
    <v-row>
      <v-col  cols="12" lg="6" offset-lg="3">
        <recording-upload
          ref="rec"
          v-if="tune"
          :tuneid="tune.id"
        ></recording-upload>
        <ctx-manager v-if="!ctx"></ctx-manager>
        <div v-else>
          <div class="overline ">
            <router-link class="primary--text" to="/home">home</router-link> >
            <router-link class="primary--text" to="/tunes">tunes</router-link> >
            {{ tune.title }}
          </div>
          <h1 class="title-logo primary--text">{{ tune.title }}</h1>
          <h2 class="grey--text">{{ tune.tune_type|capitalize }}</h2>
          <!-- <v-overlay>
            <object type="text/html" :data="sessionLink(tune.session_id)" style="width:100%; height:100%">
              <p>backup content</p>
            </object>
          </v-overlay> -->
          <v-row>
            <v-col cols="12" v-for="(rec, idx) in tune.recordings" :key="idx">
              <trad-player
                :setting="setting"
                :ctx="ctx"
                :recording="rec"
                :debug=false
                :onlyread=true
                innerHeight="32"
                onlysurf="true"
              ></trad-player>
            </v-col>
            <v-col cols="12">
              <tuto-info>
                <h4 class="pa-2">Tune details</h4>
                <p class="px-2">
                  This <strong class="primary--text">Tune details</strong> page provides information about this tune.
                </p>
                <p class="px-2">
                  You can <strong><v-icon small color="primary">mdi-play-circle</v-icon>Play recordings</strong> of the tune.
                </p>
                <p class="px-2">
                  You can view the tune on <strong>thesession.org</strong> or search for it on <strong>YouTube</strong> or <strong>Spotify</strong>.
                </p>
              </tuto-info>
            </v-col>
            <v-col cols="12">
              <strong v-if="!this.tune.default_recording">
                This tune has no recordings yet...
              </strong>
              <v-btn v-if="provideRec" color="info" large block @click="provideRec.show">
                <v-icon class="mr-2">mdi-hand-heart-outline</v-icon>
                Provide a Recording
              </v-btn>
              <p class="d-none font-italic">This feature will be coming soon !</p>
            </v-col>
            <v-col cols="12">
              <!-- {{  tune }}<br/> -->
              <!-- {{  tunes }} -->
                <h3>View on:</h3>
            </v-col>
            <v-col col="12" md="4">
              <v-btn
                block
                color="amber accent-4"
                class="social-btn amber--text session-text"
                :href="'https://thesession.org/tunes/' + tune.session_id"
                target="_blank"
              >
                <v-icon small>mdi-music-clef-treble</v-icon> The Session
              </v-btn>
            </v-col>
            <v-col col="12" md="4">
              <v-btn
                block
                color="red darken-2"
                class="social-btn white--text"
                :href="'https://www.youtube.com/results?search_query=' + tune.title.replace(' ', '+')"
                target="_blank"
              >
              <v-icon small>mdi-youtube</v-icon> YouTube
              </v-btn>
            </v-col>
            <v-col cols="12" md="4">
              <v-btn
                block
                color="green accent-4"
                class="social-btn white--text"
                :href="'https://open.spotify.com/search/' + tune.title.replace(' ', '%20')"
                target="_blank"
              >
              <v-icon small>mdi-spotify</v-icon> Spotify
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TradPlayer from '@/components/TradPlayer'
import CtxManager from '@/components/CtxManager'
import TutoInfo from '@/layout/TutoInfo.vue';
import RecordingUpload from '@/components/RecordingUpload.vue';

  export default {
  name: 'TuneDetail',
  data: function () {
    return {
      playIndex: 0,
      tuneTitle: '',
      provideRec: null,
    }  
  },
  computed: {
    ctx() { return this.$store.state.tune.ctx},
    tunes() { return this.$store.state.tune.tunes},
    tune() {
      const id = this.$route.params.id
      return this.tunes.filter(function (x) {
        if (x.id == id)
          return x
      })[0];
    },
    setting() {
      return {
        player_settings: {},
        tune: this.tune
      }
    }
  },
  components: {
    TradPlayer, CtxManager, TutoInfo, RecordingUpload
  },
  mounted() {
    var vm = this;
    this.$store.dispatch('tune/getTuneList').then(function () {
      vm.provideRec = vm.$refs['rec'];
    });
  },
  methods: {
    // this.s
    sessionLink(id) { return "https://thesession.org/tunes/" + id },
    handleDialog(val) {
      alert(val)
    }
  },
  filters: {
    capitalize(val) { 
     return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }
  }
}
</script>
<style lang="scss" scoped>
.session-text{
  color: #210000 !important;
}
.social-btn {
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
}
</style>